const ENDPOINT = {
  EXTERNAL_LOGIN: 'club/v1/forwarder/login',
  EXTERNAL_LOGOUT: 'club/v1/forwarder/logout',
};

const MODE = {
  ACTIVATE: 'ACTIVATE',
  ACTIVATE_ERROR: 'ACTIVATE_ERROR',
  FINISH_SIGNUP: 'FINISH_SIGNUP',
};

const TRACKING = 'SESSION';

const URL_PARAMS = {
  login: [MODE.FINISH_SIGNUP],
};

const SENATOR_CLUB_TOKEN = 'apiData';

const SENATOR_PROFILE_URL = {
  es: 'https://www.senatorhr.com/my-senator-profile/',
  en: 'https://www.senatorhr.com/en/my-senator-profile/',
  de: 'https://www.senatorhr.com/de/my-senator-profile/',
  fr: 'https://www.senatorhr.com/fr/my-senator-profile/',
};

export { ENDPOINT, MODE, SENATOR_CLUB_TOKEN, SENATOR_PROFILE_URL, TRACKING, URL_PARAMS };
